import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BE_API_URL,
    headers: {
        Password: process.env.REACT_APP_REDLINES_NEWS_PASSWORD_BE_API
    }
})

export default api;